import { IResponse } from '../request/calendarsResponse'

export default function(response: IResponse): number {
  const calendars = response.items.map(r => Number(r.id_calendar))
  if (calendars.length === 0) {
    throw new Error('User has no calendars!')
  }

  return calendars[0]
}
